import ClearIcon from '@mui/icons-material/Clear';
import { DateTimePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import {
  ErrorMark,
  Field as FieldShell,
  IconButton,
} from '@presov.sk/presov-ui-react';
import { sk } from 'date-fns/locale/sk';
import type { FieldValidator } from 'final-form';
import React from 'react';
import { Field } from 'react-final-form';

type Props = {
  name: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  validate?: FieldValidator<any>;
  label?: string;
  required?: boolean;
  info?: React.ReactNode;
  disabled?: boolean;
  minDate?: Date;
};

const FormDateTimePicker: React.FC<Props> = ({
  name,
  validate,
  label,
  required,
  info,
  disabled,
  minDate,
}) => {
  return (
    <Field name={name} validate={validate}>
      {({
        input: { name, value, onChange, onBlur },
        meta: { touched, error, submitError },
      }) => {
        const errorMessage = touched ? error || submitError : submitError;
        const isError = !!errorMessage;

        return (
          <FieldShell
            label={label}
            htmlFor={name}
            required={required}
            info={info}
            error={errorMessage || null}
          >
            <LocalizationProvider
              dateAdapter={AdapterDateFns}
              adapterLocale={sk}
            >
              <DateTimePicker
                value={value || null}
                onChange={onChange}
                minDate={minDate}
                minTime={minDate}
                slotProps={{
                  textField: {
                    fullWidth: true,
                    error: isError,
                    onBlur: onBlur,
                    InputProps: {
                      endAdornment: (
                        <>
                          {isError ? (
                            <ErrorMark message={errorMessage} />
                          ) : null}
                          {value && (
                            <IconButton
                              clear
                              rounded
                              sx={{
                                width: 32,
                                height: 32,
                                marginRight: -1,
                              }}
                              onClick={() => onChange(null)}
                              disabled={disabled}
                            >
                              <ClearIcon />
                            </IconButton>
                          )}
                        </>
                      ),
                    },
                  },
                }}
                disabled={disabled}
                sx={{
                  '&&': {
                    '.MuiPickersSectionList-root': {
                      padding: '0px !important',
                    },

                    // 36 px ako každé iné pole - na tom stojí celý formulár.
                    '.MuiPickersInputBase-root': {
                      height: 'auto',
                      minHeight: 36,
                    },

                    '.MuiInputAdornment-root': {
                      width: 26,
                      height: 32,
                      button: {
                        border: 'none',
                        borderRadius: '100%',
                        width: 32,
                        height: 32,
                        svg: {
                          width: 24,
                          height: 24,
                        },
                      },
                    },
                  },
                }}
              />
            </LocalizationProvider>
          </FieldShell>
        );
      }}
    </Field>
  );
};

export default FormDateTimePicker;
